// Missing privacy state is deny-by-default; precise location sync requires explicit opt-in.
export function canSyncPreciseLocation(profile: { location_tracking_enabled?: boolean | null }) {
  return profile.location_tracking_enabled === true;
}
